import * as React from 'react';
export const timeoutRef = React.createRef() as any;
export const clearTimeoutObject = () => {
    timeoutRef?.current?.clearTimeoutObject();
};

export const createTimeoutObject = (callback,timeout) => {
    timeoutRef?.current?.createTimeoutObject(callback,timeout);
};
export default {clearTimeoutObject,createTimeoutObject};